"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSIClientV1 = exports.getSIClient = void 0;
// AC
__exportStar(require("./endpoints/actions"), exports);
// TM
__exportStar(require("./endpoints/transmissionMethods"), exports);
// TC
__exportStar(require("./endpoints/transmissionConfigurations"), exports);
// IC
__exportStar(require("./endpoints/integrationConfiguration"), exports);
// Default IC
__exportStar(require("./endpoints/defaultIntegrations"), exports);
// Temporary expose migration
__exportStar(require("./migration/migration"), exports);
// Client
var client_1 = require("./endpoints/client");
Object.defineProperty(exports, "getSIClient", { enumerable: true, get: function () { return client_1.getSIClient; } });
// Types
__exportStar(require("./models/actions"), exports);
__exportStar(require("./models/transmissionMethod"), exports);
__exportStar(require("./models/integrationConfiguration"), exports);
__exportStar(require("./models/defaultIntegrations"), exports);
__exportStar(require("./models/transmissionConfiguration"), exports);
__exportStar(require("./models/transmissions/email"), exports);
__exportStar(require("./models/transmissions/fileTransfer"), exports);
__exportStar(require("./models/transmissions/promoStandards"), exports);
__exportStar(require("./models/transmissions/apiPoll"), exports);
__exportStar(require("./models/transmissions/apiPush"), exports);
__exportStar(require("./models/transmissions/siteFlow"), exports);
__exportStar(require("./mappers/transmissionConfiguration"), exports);
__exportStar(require("./models/shared"), exports);
// external helpers
__exportStar(require("./externalHelpers"), exports);
// V1
__exportStar(require("./endpoints/v1/models/responses"), exports);
__exportStar(require("./endpoints/v1/responses"), exports);
var client_2 = require("./endpoints/v1/client");
Object.defineProperty(exports, "getSIClientV1", { enumerable: true, get: function () { return client_2.getSIClientV1; } });
